import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperatorBuilder } from '../../models/builders/operator.builder';
import { Operator } from '../../models/operator';
import { OperatorCapability } from '../../models/operator-capability';
import { mapCollection } from '../../utils/collection.utils';
import { getErrorHandlingOptions } from '../base/headers';

const operatorBody = (operator: Operator) => ({
  code: operator.code,
  name: operator.name,
  workingModelGroupHash: operator.workingModelGroupHash,
  operatorGroupHash: operator.operatorGroupHash || '',
  active: operator.active,
  capabilities: mapCollection(
    (capability: OperatorCapability) => ({ modelHash: capability.modelHash, level: capability.level }),
    operator.capabilities || []
  ),
});

@Injectable()
export class OperatorApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }operators`;
  }

  getOperators(workingModelGroupHash?: string) {
    const params = (workingModelGroupHash)
      ? new HttpParams().append('workingModelGroupHash', workingModelGroupHash)
      : new HttpParams();

    return this.httpClient.get(this.apiUrl, { ...getErrorHandlingOptions(), params })
      .pipe(
        map(OperatorBuilder.fromList)
      );
  }

  getOperator(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(OperatorBuilder.fromJson)
      );
  }

  createOperator(operator: Operator) {
    return this.httpClient.post(this.apiUrl, operatorBody(operator))
      .pipe(
        map(OperatorBuilder.fromJson)
      );
  }

  updateOperator(operator: Operator) {
    return this.httpClient.put(`${ this.apiUrl }/${ operator.hash }`, operatorBody(operator))
      .pipe(
        map(OperatorBuilder.fromJson)
      );
  }

  deleteOperator(operator: Operator) {
    return this.httpClient.delete(`${ this.apiUrl }/${ operator.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operator-api.service.ts